<template>
  <header class="Header">
    <div class="container py-1 py-lg-2">
      <div class="brand-row">
        <a href="#/" class="brand-link">
          <div class="brand-mark">
            <img src="../assets/logo.svg" id="logo" alt="IMEJ Tech logo" />
            <div class="brand-copy">
              <span class="brand-name">IMEJ Tech.com</span>
              <span class="brand-tagline">Website Development &amp; Design</span>
              <div class="established">
            <i class="fas fa-globe"></i>
            <span>Established 2019</span>
          </div>
            </div>
          </div>
        </a>

        <b-navbar toggleable="lg" type="dark" class="nav-shell">
          <b-navbar-toggle target="navbar-wrapper" class="toggle-button">
            <i class="fas fa-bars"></i>
          </b-navbar-toggle>

          <b-collapse id="navbar-wrapper" is-nav>
            <b-navbar-nav class="nav-links">
              <b-nav-item href="#/">Home</b-nav-item>
              <b-nav-item to="About">About</b-nav-item>
              <b-nav-item to="Portfolio">Portfolio</b-nav-item>
              <b-nav-item to="Contact">Contact</b-nav-item>
              <b-nav-item to="Events">Events</b-nav-item>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>

        <div class="brand-meta">
          
        </div>
      </div>
    </div>
  </header>
</template>

<script>

// import { BPagination } from 'bootstrap-vue';      old code, not used in this component

export default {
  name: "Header",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Header {
  background-color: #f6f8fb;
  background-image: linear-gradient(135deg, rgba(246, 248, 251, 0.96), rgba(219, 234, 254, 0.88)), url("../assets/ai-pic5.png");
  background-size: cover;
  background-position: center;
  color: #1f2937;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.08);
  animation: backgroundMove 300s ease-in-out infinite;
}

.container {
  position: relative;
}

.brand-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-bottom: 0.05rem;
  flex-wrap: wrap;
  position: relative;
}

.brand-link {
  color: #1f2937;
  text-decoration: none;
}

.brand-link:hover {
  color: #1f2937;
  text-decoration: none;
}

.brand-mark {
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

#logo {
  height: 24px;
  width: auto;
  filter: drop-shadow(0 3px 6px rgba(0, 0, 0, 0.25));
}

.brand-copy {
  display: flex;
  flex-direction: column;
  gap: 0.02rem;
}

.brand-name {
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1.1;
}

.brand-tagline {
  font-size: 0.68rem;
  font-weight: 500;
  color: rgba(31, 41, 55, 0.75);
  line-height: 1.1;
}

.brand-meta {
  display: flex;
  align-items: center;
  margin-left: auto;
}

.established {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  padding: 0.1rem 0.4rem;
  border: 1px solid rgba(15, 23, 42, 0.12);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(8px);
  font-size: 0.75rem;
  font-weight: 600;
  color: #334155;
}

.nav-shell {
  border: none;
  padding: 0;
  justify-content: center;
  flex: 1;
}

.nav-links {
  width: 100%;
  justify-content: center;
  gap: 1.2rem;
}

.Header >>> .navbar-dark .navbar-nav .nav-link {
  font-size: 0.84rem;
  font-weight: 600;
  color: #334155;
  padding: 0.18rem 0.95rem;
  border-radius: 999px;
  transition: background-color 0.2s ease, color 0.2s ease;
}

.Header >>> .navbar-dark .navbar-nav .nav-link:hover,
.Header >>> .navbar-dark .navbar-nav .nav-link:focus {
  color: #111827;
  background-color: rgba(15, 23, 42, 0.08);
}

.Header >>> .navbar-dark .navbar-nav .nav-link.active,
.Header >>> .navbar-dark .navbar-nav .router-link-active {
  background-color: rgba(59, 130, 246, 0.16);
  color: #0f172a;
}

.Header >>> .navbar-toggler {
  border: 1px solid rgba(15, 23, 42, 0.16);
  border-radius: 999px;
  color: #1f2937;
  padding: 0.2rem 0.4rem;
}

.Header >>> .navbar-toggler:focus {
  box-shadow: none;
}

@media screen and (max-width: 768px) {
  .brand-row {
    flex-direction: column;
    align-items: flex-start;
  }

  .brand-meta {
    margin-left: 0;
  }

  .nav-shell {
    width: 100%;
    flex: auto;
  }

  .brand-name {
    font-size: 0.9rem;
  }

  .brand-tagline {
    font-size: 0.64rem;
  }
}

@keyframes backgroundMove {
  0% {
    background-position: 0% 0%;
  }
  50% {
    background-position: 100% 100%;
  }
  100% {
    background-position: 0% 0%;
  }
}
</style>
